// Library Documentation
// https://aframe.io/docs/0.9.0/introduction/

import { WINDOW } from "../constants/environment"

export default class aframe {
  constructor() {
    if (!WINDOW.AFRAME) {
      this._init()
    }
  }

  _init = () => {
    if (WINDOW && WINDOW.document && !WINDOW.aframe){
      WINDOW.aframe = true
      let script = WINDOW.document.createElement("script")
      script.src = `https://aframe.io/releases/0.8.2/aframe.min.js`
      WINDOW.document.body.appendChild(script)
      let style = WINDOW.document.createElement("style")
      style.type = 'text/css'
      let css = '.a-fullscreen, .a-html { position: relative !important } .a-body { position: relative !important; overflow: initial!important; height: auto!important; width: auto!important; }'
      style.appendChild(WINDOW.document.createTextNode(css))
      WINDOW.document.body.appendChild(style)
    }
  }

  loadAframe = ({
    callback
  }) => {
    if (WINDOW.AFRAME) {
      if (callback) {
        setTimeout(() => {
          callback()
        }, 200)
      }
    } else {
      setTimeout(() => {
        this.loadAframe({
          callback
        })
      }, 200)
    }
  }
}




// WEBPACK FOOTER //
// ./src/AtomicUtils/aframe.js